"use strict";

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncIterator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncIterator"));

var _util = require("./util");

var _queryLdflex = _interopRequireDefault(require("@solid/query-ldflex"));

var evaluatorQueue = (0, _util.createTaskQueue)();
/**
 * Evaluates a map of LDflex expressions into a singular value or a list.
 * Expressions can be changed and/or re-evaluated.
 */

var ExpressionEvaluator =
/*#__PURE__*/
function () {
  function ExpressionEvaluator() {
    _classCallCheck(this, ExpressionEvaluator);

    (0, _defineProperty2.default)(this, "pending", {});
    (0, _defineProperty2.default)(this, "cancel", false);
  }
  /** Stops all pending and future evaluations */


  _createClass(ExpressionEvaluator, [{
    key: "destroy",
    value: function destroy() {
      this.pending = {};
      this.cancel = true;
      evaluatorQueue.clear(this);
    }
    /** Evaluates the given singular value and list expressions. */

  }, {
    key: "evaluate",
    value: function () {
      var _evaluate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(values, lists, updateCallback) {
        var _this = this;

        var evaluators, statuses;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Reset the pending status and clear any errors
                updateCallback({
                  pending: true,
                  error: undefined
                }); // Create evaluators for each expression, and mark them as pending

                evaluators = evaluatorQueue.schedule([].concat(_toConsumableArray(Object.entries(values).map(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      key = _ref2[0],
                      expr = _ref2[1];

                  return function () {
                    return _this.evaluateAsValue(key, expr, updateCallback);
                  };
                })), _toConsumableArray(Object.entries(lists).map(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      key = _ref4[0],
                      expr = _ref4[1];

                  return function () {
                    return _this.evaluateAsList(key, expr, updateCallback);
                  };
                }))), this); // Wait until all evaluators are done (or one of them errors)

                _context.prev = 2;
                _context.next = 5;
                return Promise.all(evaluators);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                updateCallback({
                  error: _context.t0
                });

              case 10:
                _context.next = 12;
                return Promise.all(evaluators.map(function (e) {
                  return e.catch(function (error) {
                    console.warn('@solid/react-components', 'Expression evaluation failed.', error);
                    return true;
                  });
                }));

              case 12:
                statuses = _context.sent;

                if (!this.cancel) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                // Reset the pending flag if all are done and no others are pending
                if (!statuses.some(function (done) {
                  return !done;
                }) && Object.keys(this.pending).length === 0) updateCallback({
                  pending: false
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));

      function evaluate(_x, _x2, _x3) {
        return _evaluate.apply(this, arguments);
      }

      return evaluate;
    }()
    /** Evaluates the property expression as a singular value. */

  }, {
    key: "evaluateAsValue",
    value: function () {
      var _evaluateAsValue = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(key, expr, updateCallback) {
        var promise, value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Obtain and await the promise
                promise = this.pending[key] = this.resolveExpression(expr);
                _context2.prev = 1;
                _context2.next = 4;
                return promise;

              case 4:
                value = _context2.sent;

                if (!(this.pending[key] !== promise)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", false);

              case 7:
                _context2.prev = 7;

                if (this.pending[key] === promise) {
                  delete this.pending[key];
                  updateCallback(_defineProperty({}, key, value));
                }

                return _context2.finish(7);

              case 10:
                return _context2.abrupt("return", true);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 7, 10]]);
      }));

      function evaluateAsValue(_x4, _x5, _x6) {
        return _evaluateAsValue.apply(this, arguments);
      }

      return evaluateAsValue;
    }()
    /** Evaluates the property expression as a list. */

  }, {
    key: "evaluateAsList",
    value: function () {
      var _evaluateAsList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(key, expr, updateCallback) {
        var _this2 = this;

        var empty, items, iterable, update, updateQueue, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, needsUpdate;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Read the iterable's items, throttling updates to avoid congestion
                empty = true;
                items = [];
                iterable = this.pending[key] = this.resolveExpression(expr);

                update = function update() {
                  return !_this2.cancel && updateCallback(_defineProperty({}, key, [].concat(items)));
                };

                updateQueue = (0, _util.createTaskQueue)({
                  timeBetween: 100,
                  drop: true
                });
                _context3.prev = 5;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context3.prev = 8;
                _iterator = (0, _asyncIterator2.default)(iterable);

              case 10:
                _context3.next = 12;
                return _iterator.next();

              case 12:
                _step = _context3.sent;
                _iteratorNormalCompletion = _step.done;
                _context3.next = 16;
                return _step.value;

              case 16:
                _value = _context3.sent;

                if (_iteratorNormalCompletion) {
                  _context3.next = 28;
                  break;
                }

                item = _value; // Stop if another evaluator took over in the meantime (component update)

                if (!(this.pending[key] !== iterable)) {
                  _context3.next = 22;
                  break;
                }

                updateQueue.clear();
                return _context3.abrupt("return", false);

              case 22:
                // Add the item and schedule an update
                empty = false;
                items.push(item);
                updateQueue.schedule(update);

              case 25:
                _iteratorNormalCompletion = true;
                _context3.next = 10;
                break;

              case 28:
                _context3.next = 34;
                break;

              case 30:
                _context3.prev = 30;
                _context3.t0 = _context3["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 34:
                _context3.prev = 34;
                _context3.prev = 35;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context3.next = 39;
                  break;
                }

                _context3.next = 39;
                return _iterator.return();

              case 39:
                _context3.prev = 39;

                if (!_didIteratorError) {
                  _context3.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context3.finish(39);

              case 43:
                return _context3.finish(34);

              case 44:
                _context3.prev = 44;
                needsUpdate = empty || updateQueue.clear();

                if (this.pending[key] === iterable) {
                  delete this.pending[key];
                  if (needsUpdate) update();
                }

                return _context3.finish(44);

              case 48:
                return _context3.abrupt("return", true);

              case 49:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5,, 44, 48], [8, 30, 34, 44], [35,, 39, 43]]);
      }));

      function evaluateAsList(_x7, _x8, _x9) {
        return _evaluateAsList.apply(this, arguments);
      }

      return evaluateAsList;
    }()
    /** Resolves the expression into an LDflex path. */

  }, {
    key: "resolveExpression",
    value: function resolveExpression(expr) {
      // Ignore an empty expression
      if (!expr) return ''; // Resolve an LDflex string expression
      else if (typeof expr === 'string') return _queryLdflex.default.resolve(expr); // Return a resolved LDflex path (and any other object) as-is
        else return expr;
    }
  }]);

  return ExpressionEvaluator;
}();

exports.default = ExpressionEvaluator;